module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/531bf128a68a406afdae579d0dfa4db8.png";